import React from "react";

import CollectGraphicsModals from "../modals";
import { FilterParamsList } from "components/service";

const CollectGraphicsFilterBlock = ({ filter }) => {
    return (
        <div className="filter-block collect-graphics-filter-block">
            <div className="modals grid-two-col">
                <CollectGraphicsModals.Filter filter={filter} />
            </div>
            <FilterParamsList
                filter={filter}
                fieldsArr={["where", "whereCrafts"]}
            />
        </div>
    );
};

export default CollectGraphicsFilterBlock;
